import React, {PureComponent, Fragment} from 'react';
import {FastField, FieldArray, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import get from 'lodash/get';
import range from 'lodash/range';
import classNames from 'classnames';
import messages from '../../../../../res/translations/messages';
import FormGroup from '../FormGroup';
import FormRow from '../FormRow';
import CommonFields from './CommonFields';
import LabelsType from '../LabelsType';
import Error from '../../../Error';
import {MULTIPLE_NUMBER_1_PRESETS} from '../../../../constants';
class MultipleNumber1Type extends PureComponent {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.upgradeFromLegacy();
    }

    upgradeFromLegacy() {
        const {name, form} = this.props;
        if (this.isLegacy()) {
            const {min, max, step} = get(form.values, `${name}`);
            const itemLegacyPreset = this.findLegacyPreset(
                min, max, step,
            );
            if (itemLegacyPreset) {
                this.props.form.setFieldValue(`${this.props.name}.preset`, itemLegacyPreset.id);
            } else {
                this.props.form.setFieldValue(`${this.props.name}.preset`, 0);
            }
        }
    }

    findLegacyPreset(min, max, step) {
        return MULTIPLE_NUMBER_1_PRESETS.filter((i) => i.min === min && i.max === max && i.step === step)[0];
    }

    findPreset(id) {
        return MULTIPLE_NUMBER_1_PRESETS.filter((i) => i.id === id)[0];
    }

    isLegacy() {
        const {name, form} = this.props;
        const {min, max, preset} = get(form.values, `${name}`);
        return !!( (!preset || preset === 0) && (min || max) );
    }

    handleChange(e) {
        const {name, form} = this.props;
        const value = parseInt(e.target.value);

        const item = this.findPreset(value);

        if (item) {
            form.setFieldValue(`${name}.preset`, value);
            form.setFieldValue(`${name}.min`, item.min);
            form.setFieldValue(`${name}.max`, item.max);
            form.setFieldValue(`${name}.step`, item.step);
        }
    }

    render() {
        const {name, form, previousPages} = this.props;
        const {min, max, step} = get(form.values, `${name}`);

        return (
            <Fragment>
                <CommonFields name={name} form={form} required={true} previousPages={previousPages} />
                {this.isLegacy() ? (
                    <>
                        <div className="row">
                            <FormGroup name={`${name}.min`} label={messages.surveys.form.label.min} size={3} tooltip={messages.surveys.form.tooltip.min}>
                                <FastField id={`${name}.min`} name={`${name}.min`} type="number" step="any"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.min`) && (get(form.touched, `${name}.min`) || form.submitCount > 0)})} />
                                {(get(form.touched, `${name}.min`) || form.submitCount > 0) && get(form.errors, `${name}.min`) &&
                                    <Error reason={get(form.errors, `${name}.min`).key} reasonParams={get(form.errors, `${name}.min`).params} />}
                            </FormGroup>
                            <FormGroup name={`${name}.max`} label={messages.surveys.form.label.max} size={3} tooltip={messages.surveys.form.tooltip.max}>
                                <FastField id={`${name}.max`} name={`${name}.max`} type="number" step="any"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.max`) && (get(form.touched, `${name}.max`) || form.submitCount > 0)})} />
                                {(get(form.touched, `${name}.max`) || form.submitCount > 0) && get(form.errors, `${name}.max`) &&
                                    <Error reason={get(form.errors, `${name}.max`).key} reasonParams={get(form.errors, `${name}.max`).params} />}
                            </FormGroup>
                        </div>
                        <FormRow name={`${name}.step`} label={messages.surveys.form.label.step} size={3} tooltip={messages.surveys.form.tooltip.step}>
                            <FastField id={`${name}.step`} name={`${name}.step`} type="number" step="any"
                                className={classNames('form-control',
                                    {error: get(form.errors, `${name}.step`) && (get(form.touched, `${name}.step`) || form.submitCount > 0)})} />
                            {(get(form.touched, `${name}.step`) || form.submitCount > 0) && get(form.errors, `${name}.step`) &&
                                <Error reason={get(form.errors, `${name}.step`).key} reasonParams={get(form.errors, `${name}.step`).params} />}
                        </FormRow>
                    </>
                ) : (
                    <div className="row">
                        <FormGroup name={`${name}.preset`} size={12} label={messages.surveys.form.label.preset}>
                            <FastField id={`${name}.preset`} name={`${name}.preset`} component="select" onChange={this.handleChange}
                                className={classNames('form-control custom-select',
                                    {error: get(form.errors, `${name}.preset`) && (get(form.touched, `${name}.preset`) || form.submitCount > 0)})}>
                                <option value="" disabled />
                                {MULTIPLE_NUMBER_1_PRESETS.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
                            </FastField>
                            {(get(form.touched, `${name}.preset`) || form.submitCount > 0) && get(form.errors, `${name}.preset`) &&
                                <Error reason={get(form.errors, `${name}.preset`).key} reasonParams={get(form.errors, `${name}.preset`).params} />}
                        </FormGroup>
                        {min !== '' ?
                            <FormGroup size={12} label={messages.surveys.form.label.example}>
                                <div className="rulerContainer">
                                    {(range(min, max + 1, step).map((i) =>
                                        <div className="item" key={i}>{i}</div>,
                                    ))}
                                </div>
                            </FormGroup> :
                            null}
                    </div>
                )}
                <div className="form-group">
                    <h4>
                        &gt; <FormattedMessage {...messages.surveys.form.label.rows} />
                    </h4>
                    <FieldArray name={`${name}.rows`} component={LabelsType} />
                    <ErrorMessage name={`${name}.rows`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </div>

            </Fragment>
        );
    }
}

export default MultipleNumber1Type;
